import { WEBSOCKET_STREAM_URL } from '../constants/configuration';

export class StreamWebsocketInstance {
  static #instance;
  #ws = null;

  constructor() {
    if (typeof StreamWebsocketInstance.instance !== 'undefined') {
      throw new Error('Singleton class cannot be instantiated directly. Use get() method instead.');
    }
  }

  static get() {
    if (!StreamWebsocketInstance.#instance) {
      StreamWebsocketInstance.#instance = new StreamWebsocketInstance();
      return StreamWebsocketInstance.#instance;
    }
    return StreamWebsocketInstance.#instance;
  }

  open() {
    if (this.#ws) return Promise.resolve();

    return new Promise((resolve) => {
      const access_token = localStorage.getItem('access_token');
      if (!WEBSOCKET_STREAM_URL) {
        resolve();
        return;
      }

      const ws = new WebSocket(`${WEBSOCKET_STREAM_URL}?token=${access_token}`);
      this.#ws = ws;

      ws.onopen = () => {
        console.log('ws connected');
        resolve();
      };
      ws.onclose = () => {
        if (this.#ws === ws) this.#ws = null;
        console.log('ws disconnected');
        resolve();
      };
      ws.onerror = (error) => {
        console.log(error);
      };
      ws.onmessage = (data) => {
        console.log(data);
      };
    });
  }

  close() {
    const ws = this.#ws;
    this.#ws = null;
    if (!ws) return Promise.resolve();

    return new Promise((resolve) => {
      ws.addEventListener('close', () => resolve());
      ws.close();
    });
  }

  ws() {
    return this.#ws;
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', () => {
    StreamWebsocketInstance.get().close();
  });
}
